var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgZoomOut = function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.25v1.5q0 .305-.223.527-.222.223-.527.223H3.75q-.305 0-.527-.223Q3 10.055 3 9.75v-1.5q0-.305.223-.527.222-.223.527-.223h10.5q.305 0 .527.223.223.222.223.527Zm3 6.375V3.375Q18 1.98 17.01.99 16.02 0 14.625 0H3.375Q1.98 0 .99.99 0 1.98 0 3.375v11.25q0 1.395.99 2.385.99.99 2.385.99h11.25q1.395 0 2.385-.99.99-.99.99-2.385Z"
  })));
};
export default SvgZoomOut;